/* as.if.records: Farbe der iPhone-Statusleiste (24.09.2026)
   Safari 26 und installierte Web-Apps malen den Streifen oben (Uhr, Empfang,
   Akku) aus der Hintergrundfarbe von <body>, nicht aus theme-color, und
   aktualisieren ihn live, wenn sich die Farbe von <body> aendert. Beim weichen
   Seitenwechsel blieb der Streifen deshalb in der Seitenfarbe (Papier, fast
   weiss) stehen.
   Dieses Skript misst, was oben im Bild tatsaechlich zu sehen ist (Kopf,
   Bereichsleiste, Buehne), und gibt <body> genau diese Farbe. Der Seiteninhalt
   behaelt seine eigene Farbe, weil <main> und der Fussbereich die urspruengliche
   Seitenfarbe als eigenen Hintergrund bekommen. theme-color wird fuer aeltere
   iOS-Versionen und Android mitgezogen. */
(() => {
  if (window.__asifTopTint) return;
  window.__asifTopTint = true;

  const INK = 'rgb(24, 26, 26)';
  const root = document.documentElement;
  const parse = (value) => {
    const m = /rgba?\(([^)]+)\)/.exec(value || '');
    if (!m) return null;
    const parts = m[1].split(/[ ,/]+/).filter(Boolean).map(Number);
    return { r: parts[0], g: parts[1], b: parts[2], a: parts.length > 3 ? parts[3] : 1 };
  };
  const hex = (c) => '#' + [c.r, c.g, c.b].map((n) => Math.round(n).toString(16).padStart(2, '0')).join('');

  // Seitenfarbe aus dem Stylesheet (--asif-page-color, asif-type-system.css).
  const pageColor = () => getComputedStyle(document.body).getPropertyValue('--asif-page-color').trim() || 'rgb(243, 241, 232)';

  // Was liegt oben in der Bildmitte? Erstes deckendes Element gewinnt.
  // Liegt ein Bild oder Video zuerst (Kopf durchsichtig ueber einem Titelbild),
  // ist der Grund dunkel: Tinte.
  const topColor = (fallback) => {
    // Am linken Rand messen: in der Mitte steht auf dem Handy das Logo.
    const width = window.innerWidth;
    let stack = [];
    try { stack = document.elementsFromPoint(3, 1); } catch (error) { return fallback; }
    for (const el of stack) {
      if (el === document.body || el === root) break;
      if (el.closest && el.closest('[data-asif-top-tint-ignore], .shopify-preview-bar, #preview-bar-iframe')) continue;
      const tag = el.tagName;
      if (tag === 'IMG' || tag === 'VIDEO' || tag === 'PICTURE' || tag === 'CANVAS') {
        // Nur grosse Bilder zaehlen (Titelbild), keine Symbole oder Logos.
        if (el.getBoundingClientRect().width >= width * 0.5) return INK;
        continue;
      }
      const c = parse(getComputedStyle(el).backgroundColor);
      if (c && c.a >= 0.85) return `rgb(${c.r}, ${c.g}, ${c.b})`;
    }
    return fallback;
  };

  let last = '';
  const apply = () => {
    if (!document.body) return;
    const top = topColor(pageColor());
    if (!root.classList.contains('asif-top-tinted')) root.classList.add('asif-top-tinted');
    if (top !== last) {
      last = top;
      root.style.setProperty('--asif-top-bg', top);
    }
    const meta = document.querySelector('meta[data-asif-theme-color]');
    const c = parse(top) || parse(getComputedStyle(document.body).backgroundColor);
    if (meta && c && meta.content !== hex(c)) meta.content = hex(c);
  };

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => { frame = 0; apply(); });
  };
  // Mehrfach nach dem Laden und nach einem Seitenwechsel: Kopf, Buehnenfarbe und
  // Radio-Modus setzen ihre Farben mit kurzen Uebergaengen.
  const settle = () => { schedule(); [150, 600, 1600].forEach((ms) => window.setTimeout(schedule, ms)); };

  document.addEventListener('asif:page', settle);
  window.addEventListener('pageshow', settle);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  document.addEventListener('transitionend', (event) => {
    if (event.target === document.body || event.target?.classList?.contains?.('shopify-section--header') || event.target?.classList?.contains?.('header')) schedule();
  }, true);
  const observer = new MutationObserver(schedule);
  const watch = () => {
    observer.observe(root, { attributes: true, attributeFilter: ['data-asif-radio-mode'] });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class', 'data-aura-base'] });
    const header = document.querySelector('.header');
    if (header) observer.observe(header, { attributes: true, attributeFilter: ['class'] });
  };
  const start = () => { watch(); settle(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('asif:page', () => { observer.disconnect(); watch(); });
})();
